export const SIGN_UP_FUNNEL_VALUE_PROPS = [
  "components.auth.valueProps.saveReadingHistory",
  "components.auth.valueProps.getAlerts",
  "components.auth.valueProps.getPowerfulRecommendations",
];
